import { render } from "./user-details-modal.vue?vue&type=template&id=7896616c&ts=true"
import script from "./user-details-modal.vue?vue&type=script&lang=ts"
export * from "./user-details-modal.vue?vue&type=script&lang=ts"

import "./user-details-modal.vue?vue&type=style&index=0&id=7896616c&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__